export function Loading() {
  return <p className="py-8 text-center text-sm text-gray-500">Loading…</p>;
}
